import { jsxs as c, jsx as a } from "react/jsx-runtime";
import { Modal as e } from "../components/Modal.js";
import { InfoIcon as s } from "../../../assets/svgs/InfoIcon.js";
const u = ({
  setIsCloseModalEmpty: t,
  genericTaggingEvent: o
}) => {
  const r = () => {
    t(!1);
  };
  return /* @__PURE__ */ c(
    e,
    {
      closeModal: r,
      title: "Cupons de desconto",
      genericTaggingEvent: o,
      cancelButtonText: "Voltar para Meus Cupons",
      cancelButtonAction: () => {
        o == null || o("discount_coupon", {
          name: "Modal do cart vazio - botão de sair"
        }), r();
      },
      redirectionClubText: "Ver Minhas Ofertas",
      children: [
        /* @__PURE__ */ a("h3", { className: "cartEmptyCoupon-h3", children: "Ops...Parece que seu carrinho está vazio..." }),
        /* @__PURE__ */ c("p", { id: "cartEmptyCoupon-p", children: [
          /* @__PURE__ */ a("span", { children: /* @__PURE__ */ a(s, {}) }),
          "Para adicionar um cupom é necessário que você adicione pelo menos 1 produto no carrinho"
        ] })
      ]
    }
  );
};
export {
  u as EmptyCartView
};
